import { ConstantsLagoon } from '../common/ConstantsLagoon';
import { getFeatureFlags } from '../common/Utils/getFeatureFlag';
import { useLagoon } from '../hooks/useLagoon';

const toArray = (value: unknown): string[] => {
  if (Array.isArray(value)) return value;
  if (typeof value === 'string')
    return value.split(',').map((item) => item.trim());
  return [];
};

export const getAiBioEligibility = (
  policyNumber: string,
  currentSelectedState?: string
) => {
  // 1. Check API feature flag first
  const featureFlags = useLagoon('feature-flags')();
  const [showProviderBioApiFlag] = getFeatureFlags(featureFlags, [
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_PROVIDER_AI_BIO_API,
  ]);
  if (!showProviderBioApiFlag) return false;

  // 2. Validate required inputs
  if (!policyNumber || !currentSelectedState) return false;

  const featureInclusion = useLagoon('feature-inclusion')();
  const aiBioFeatureRow = featureInclusion?.find(
    (row) =>
      row.dntFeature ===
      ConstantsLagoon.FEATURE_INCLUSION_FLAGS.AI_BIO_ELIGIBILITY_STATES
  );

  if (!aiBioFeatureRow) return false;
  const { policyIds, situsState } = aiBioFeatureRow;

  // 3. Convert data to arrays, handling both string and array types
  const policyIdsArray = toArray(policyIds);
  const situsStateArray = toArray(situsState);

  // 4. Check if the configuration arrays are empty
  if (policyIdsArray.length === 0 || situsStateArray.length === 0) {
    return false;
  }

  // 5. Perform the final eligibility check
  return (
    policyIdsArray.includes(policyNumber) &&
    situsStateArray.includes(currentSelectedState)
  );
};
